import { useState } from "react";
import Snake from "./../../../../assets/images/picture/snake_image.png";
import { ReactComponent as FaceSymbol } from "./../../../../assets/images/icon/face-symbole.svg";
import { ReactComponent as TrueMark } from "./../../../../assets/images/icon/true-mark.svg";
import ViewHeightFull from "./../../../common/viewHeightFull";
import { withRouter } from "react-router-dom";
function FeedbackStep(props) {
  const [hsaFeedback, setHasFeedback] = useState(false);
  const [ratingState, setRatingState] = useState(1);
  const [questions, setQuestions] = useState([
    {
      question:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Provident ?",
      answer: null,
    },
    {
      question:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Provident ?",
      answer: null,
    },
    {
      question:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Provident ?",
      answer: null,
    },
    {
      question:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Provident ?",
      answer: null,
    },
    {
      question:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Provident ?",
      answer: null,
    },
  ]);
  const submitFormHandler = (event) => {
    event.preventDefault();
    setHasFeedback(true);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };
  return (
    <div className="feedback__step">
      {!hsaFeedback && (
        <div className="get__feedback">
          <div className="snake__info">
            <div className="image">
              <img src={Snake} alt="" />
            </div>
            <p>
              Your selected result : <span>KIng kobra</span>
            </p>
          </div>
          {/* <div className="feedback__rating">
            <p>Did you get the result you wanted ?</p>
            <div className="feedback__item__box">
              <ul class="feedback">
                <li
                  class={`angry ${ratingState === 1 ? "active" : ""}`}
                  onClick={() => setRatingState(1)}
                >
                  <div>
                    <svg class="eye left">
                      <use href="#eye"></use>
                    </svg>
                    <svg class="eye right">
                      <use href="#eye"></use>
                    </svg>
                    <svg class="mouth">
                      <use href="#mouth"></use>
                    </svg>
                  </div>
                </li>
                <li
                  class={`sad ${ratingState === 2 ? "active" : ""}`}
                  onClick={() => setRatingState(2)}
                >
                  <div>
                    <svg class="eye left">
                      <use href="#eye"></use>
                    </svg>
                    <svg class="eye right">
                      <use href="#eye"></use>
                    </svg>
                    <svg class="mouth">
                      <use href="#mouth"></use>
                    </svg>
                  </div>
                </li>
                <li
                  class={`ok ${ratingState === 3 ? "active" : ""}`}
                  onClick={() => setRatingState(3)}
                >
                  <div></div>
                </li>
                <li
                  class={`good ${ratingState === 4 ? "active" : ""}`}
                  onClick={() => setRatingState(4)}
                >
                  <div>
                    <svg class="eye left">
                      <use href="#eye"></use>
                    </svg>
                    <svg class="eye right">
                      <use href="#eye"></use>
                    </svg>
                    <svg class="mouth">
                      <use href="#mouth"></use>
                    </svg>
                  </div>
                </li>
                <li
                  class={`happy ${ratingState === 5 ? "active" : ""}`}
                  onClick={() => setRatingState(5)}
                >
                  <div>
                    <svg class="eye left">
                      <use href="#eye"></use>
                    </svg>
                    <svg class="eye right">
                      <use href="#eye"></use>
                    </svg>
                  </div>
                </li>
              </ul>
              <FaceSymbol />
            </div>
          </div> */}
          <div className="form__wrapper">
            <form>
              <div className="items">
                {/* <div className="item">
                  <label htmlFor="">Your name</label>
                  <input type="text" placeholder="ex: john doe" />
                </div> */}
                <div className="item">
                  <label htmlFor="" className="is__required">
                    Email
                  </label>
                  <input type="text" placeholder="ex: test@gmail.com" />
                </div>
                {/* <div className="item">
                  <label htmlFor="">Comment</label>
                  <input type="text" placeholder="ex : this is my comment" />
                </div> */}
              </div>
              <div className="questions__box">
                <div className="items">
                  {questions &&
                    questions.map((item, index) => {
                      return (
                        <div className="item" key={index}>
                          <label htmlFor="">{item.question}</label>
                          <div className="checks__items">
                            <div className="item">
                              <label htmlFor={`${index + 1}-${index * 10}-ans`}>
                                Yes
                              </label>
                              <input
                                type="radio"
                                name={`${index}-ans-${index * 5}`}
                                id={`${index + 1}-${index * 10}-ans`}
                              />
                            </div>
                            <div className="item">
                              <label htmlFor={`${index + 2}-${index * 10}-ans`}>
                                No
                              </label>
                              <input
                                type="radio"
                                name={`${index}-ans-${index * 5}`}
                                id={`${index + 2}-${index * 10}-ans`}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="items">
                <div className="item">
                  <label htmlFor="">Comment</label>
                  <textarea type="text" placeholder="ex : this is my comment" />
                </div>
              </div>
              <div className="button__wrapper">
                <button
                  type="submit"
                  onClick={(event) => submitFormHandler(event)}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {hsaFeedback && (
        <ViewHeightFull>
          <div className="thank__you__feedback">
            <TrueMark />
            <div className="actions">
              <h4>Thank you for helping us get better</h4>
              <div className="two">
                <button
                  className="green__button"
                  onClick={() => props.history.push("/")}
                >
                  Home
                </button>
                <button
                  className="blue__button"
                  onClick={() => props.changeStep(1)}
                >
                  Upload another image
                </button>
              </div>
            </div>
          </div>
        </ViewHeightFull>
      )}
    </div>
  );
}

export default withRouter(FeedbackStep);
